<ng-container *transloco="let t; read: 'maintenance'">
  <div class="centered-container">
    <img width="100px" src="/assets/images/brandmark-bright-blue.png" />
    <h3>{{ t('ErgoPlus is down for scheduled maintenance.') }}</h3>
    <div>
      <button mat-button (click)="backToLogin()">
        {{ t('Back to login') }}
      </button>
    </div>
  </div>
</ng-container>
